/**
 * Class FileRequestItem
 * @param datasrc {String} enum of the datasource to load
 * @param refresh {Boolean} expire y-or-n
 * @param params {Object} name value pairs datasource needs to fill in parameters in the url
 * @param handler {function} scoped callback function
 * @returns {Object} all the above as name-value pairs
 *
 * This is a helper class to simplify repeatedly making the obj of name value pairs needed for the datasource manager
 */
define('GameDayCore/GDModel/load/execute/FileRequestItem',['require','exports','module'],function(require,exports,module) {
    function FileRequestItem(datasrc, refresh, params, handler) {
        this.dataSourceName = datasrc;
        this.refresh    = refresh;
        this.params     = params;
        this.callback   = handler || this.callback;
    };

    FileRequestItem.prototype={
        callback : null
    }

    return FileRequestItem;
});
